import MultiselectInput from './MultiselectInput'

export default MultiselectInput
